@defer (when event$ | async){
<app-boilerplate>
  @if (event$ | async; as lrpEvent){
    <app-event-summary [event]="lrpEvent" (bookingButtonClicked)="activeTab = 'booking'"/>
    <p-tabs [value]="activeTab">
      <p-tablist class="dark:bg-stone-800" styleClass="bg-none">
        <p-tab value="invitation">Invitation</p-tab>
        <p-tab value="information">Event Information</p-tab>
        @if (lrpEvent.eventsCaterings?.display) {
          <p-tab value="catering">Catering Choices</p-tab>
        }
        @if (loggedIn && lrpEvent.eventAttendees) {
          <p-tab value="attendees">Attendees</p-tab>
        }
        <p-tab value="organiser">Event Organiser</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="invitation" header="Invitation">
          <app-parchment-invite [event]="lrpEvent"/>
        </p-tabpanel>
        <p-tabpanel value="information" header="Event Information">
          <div [innerHTML]="lrpEvent.fullDescription">
          </div>
        </p-tabpanel>
        @if (lrpEvent.eventsCaterings?.display){
          <p-tabpanel value="catering">
            <p [innerHTML]="(lrpEvent.eventsCaterings)?.notes"></p>
            @if(lrpEvent.eventsCaterings; as eventCatering){
              @if (eventCatering | CateringDates; as cateringDays){
                <p-tabs header="Catering Choices" [value]="cateringDays[0]?.getDate()">
                  <p-tablist>
                    @if (cateringDays.length > 1){
                      @for (cateringDay of cateringDays; track cateringDay){
                        <p-tab [value]="cateringDay.getDate()">{{ cateringDay.toLocaleString('en-gb', {weekday:'long'}) | titlecase }}</p-tab>
                      }
                    }
                  </p-tablist>
                  <p-tabpanels>
                    @for (cateringDay of cateringDays; track $index){
                      @for (menu of eventCatering.menu; track menu.id){
                        <p-tabpanel [value]="cateringDay.getDate()">
                          @if (parseDate(menu.date).getDate() === cateringDay.getDate()) {
                            <h3 class="font-semibold text-lg">{{ menu.name }}</h3>
                            <ul>
                              @for (option of menu.options;track option.id){
                                <li>{{ option.option }}</li>
                              }
                            </ul>
                          }
                        </p-tabpanel>
                      }
                    }
                    @for (cateringDay of cateringDays; track cateringDay){
                      @for (menu of lrpEvent?.eventsCaterings?.menu; track menu.id){
                        <p-tabpanel [value]="cateringDay.getDate()">
                          @if (parseDate(menu.date).getDate() === cateringDay.getDate()) {
                            <h3 class="font-semibold text-lg">{{ menu.name }}</h3>
                            <ul>
                              @for (option of menu.options;track option.id){
                                <li>{{ option.option }}</li>
                              }
                            </ul>
                          }
                        </p-tabpanel>
                      }
                    }
                  </p-tabpanels>
                </p-tabs>
              }
            }
          </p-tabpanel>
        }
        @if (loggedIn && lrpEvent.eventAttendees){
          <p-tabpanel value="attendees">
            <app-attendee-list [eventAttendees]="lrpEvent.eventAttendees" />
          </p-tabpanel>
        }
        <p-tabpanel value="organiser">
          <p class="mb-3">This event is a {{ lrpEvent.eventHost.eventSystem.name }} event
          @if (lrpEvent.eventHost.display){
            hosted by {{ lrpEvent.eventHost.name}}
          }.</p>
          @if (lrpEvent.organiser){
            
          }
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  }
</app-boilerplate>
}
@placeholder {
<app-loading />
}